'use client';

import { WagtailImage } from '@/types';
import Button from '@components/Button';
import { useEffect, useId, useState } from 'react';
import cookie from 'cookie';

const COOKIE_NAME = 'google-maps';
const COOKIE_VALUE = 'allowed';

type Props = {
  placeholder_image?: WagtailImage;
};

function Map(props: Props) {
  const { placeholder_image } = props;
  const id = useId();

  const [googleMapsAccepted, setGoogleMapsAccepted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setGoogleMapsAccepted(Boolean(document?.cookie?.includes(`${COOKIE_NAME}=${COOKIE_VALUE}`)));
  }, []);

  return (
    <>
      {googleMapsAccepted ? (
        <iframe
          className='google-maps__iframe'
          loading='lazy'
          src='https://maps.google.com/maps?q=isits%20AG%20International%20School%20of%20IT%20Security%20Huestr.%2030%2044787%20Bochum&amp;t=m&amp;z=15&amp;output=embed&amp;iwloc=near'
          title='isits AG International School of IT Security Huestr. 30 44787 Bochum'
          aria-label='isits AG International School of IT Security Huestr. 30 44787 Bochum'
        ></iframe>
      ) : (
        <div className='google-maps__placeholder'>
          <p id={`${id}-google-maps-consent`} className='youtube__placeholder-text'>
            Mit dem Klick auf den folgenden Button stimmen Sie zu, dass Daten von Google Maps geladen werden dürfen. Sie
            finden Informationen hierzu in unserer Datenschutzerklärung.
          </p>
          <Button
            primary
            tertiary
            onClick={() => {
              setGoogleMapsAccepted(true);
              document.cookie = cookie.serialize(COOKIE_NAME, COOKIE_VALUE);
            }}
            aria-describedby={`${id}-google-maps-consent`}
          >
            GoogleMaps aktivieren
          </Button>
        </div>
      )}
    </>
  );
}

export default Map;
